import {ApplicationEntity} from "@/model/entity/application-entity"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {Exclude} from "class-transformer"

export class Shipnotify extends ApplicationEntity {

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.shipnotify.filename",
    isFilterable: true
  })
  filename: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.shipnotify.created"
  })
  createdDate: number

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.shipnotify.status"
  })
  shipnotifyStatus: string

  @Exclude()
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.shipnotify.officeNames"
  })
  officeNames?: string[]

  constructor(
    filename: string,
    shipnotifyStatus: string,
    createdDate: number,
    id?: number
  ) {
    super(id)
    this.filename = filename
    this.shipnotifyStatus = shipnotifyStatus
    this.createdDate = createdDate
  }
}
